import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import ActionButton from "../components/ActionButton";
import PanelGroupController from "../components/PanelGroupController";
import PanelHeaderItem from "../components/PanelHeaderItem";
import DeliveryList from "./views/DeliveryList";
import SubscriptionInfoPanel from "./panels/SubscriptionInfoPanel";
import DeliveryInfoPanel from "./panels/DeliveryInfoPanel";
import LogPanel from "./panels/LogPanel";
import ShippingInfoPanel from "../shipping/panels/ShippingInfoPanel";
import ShippingStatusPanel from "../shipping/panels/ShippingStatusPanel";
import gql from "graphql-tag";
import {connect} from "react-redux";
import {withApollo, graphql} from "react-apollo";
import Loading from "../components/Loading";
import GraphQLErrors from "../components/GraphQLErrors";
import {List} from "immutable";
import NotesPanel from "../notes/panels/NotesPanel";
import { requestCreateNote } from "../notes/NotesActions";
import {SUBSCRIPTION_TYPE} from "../notes/notes";
import {
  requestChangeSubscriptionFrequency,
  requestChangeSubscriptionQuantity,
  requestChangeSubscriptionShippingAddress,
  requestRescheduleSubscriptionDelivery,
  requestCancelSubscription,
  requestRestartSubscription,
  requestRenameSubscription,
  requestViewSubscriptionDelivery,
  } from "../actions/AccountApiActions";

class SubscriptionDeliveriesPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.handleDeliveryIdClick = this.handleDeliveryIdClick.bind(this);
    this.handlePanelItemSelection = this.handlePanelItemSelection.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.state = {
      deliveryId: "",
      hasDeliverySelection: false,
      selectedPanelId: "subscription",
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.params.subscriptionId !== this.props.params.subscriptionId) {
      this.setState({
        subscriptionId: "",
        hasSubscriptionSelection: false,
        selectedPanelId: "subscription"
      })
    }
  }

  render() {
    let {loading, error} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />        

    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);


    let title = `Subscriptions / ${this.props.data.subscriptionInfo.subscriptionId}`;

    return (
      <div className="SalesPage SubscriptionDeliveriesPage SecurePage">
        <AppSidebar />
        <PageHeader title={title} backButton={true} onBack={this.handleBack}/>
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header">
            <PanelHeaderItem label="Subscription" id="subscription" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem label="Delivery" id="delivery" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem label="Log" id="log" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem show={false} label="Shipping" id="shipping" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />
            <PanelHeaderItem label="Notes" id="notes" selectedId={this.state.selectedPanelId} onClick={this.handlePanelItemSelection} />            
          </div>
          {panels}
        </div>
      </div>
    );
  }

  renderView(page) {
    switch(page) {
      case "subscription":
        return (
          <DeliveryList
            subscriptionId={this.props.data.subscriptionInfo.subscriptionId}
            selectedId={this.state.deliveryId}
            onSelectionChange={this.handleSetSelection}
            onIdClick={this.handleDeliveryIdClick}
            />
        )
      default: 
        return <p>No view found</p>
    }
  }

  renderPanels(page) {
    switch(page) {
      case "subscription":
        if (this.state.selectedPanelId === "subscription") {
          return this.buildPanels(List([SubscriptionInfoPanel, "subscriptionActions"]));
        } else if (this.state.selectedPanelId === "delivery") {
          return this.buildPanels(List([DeliveryInfoPanel, "deliveryActions"]));
        } else if (this.state.selectedPanelId === "log") {
          return this.buildPanels(List([LogPanel]));
        } else if (this.state.selectedPanelId === "notes") {
          return this.buildPanels(List([NotesPanel]));
        }

        break;
      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map(x => this.buildPanel(x));
  }

  buildPanel(component) {
    switch(component) {
      case SubscriptionInfoPanel:
        return <SubscriptionInfoPanel key="SubscriptionInfoPanel" subscriptionId={this.props.data.subscriptionInfo.subscriptionId} />

      case DeliveryInfoPanel:
        return <DeliveryInfoPanel key="DeliveryInfoPanel" deliveryId={this.state.deliveryId} />

      case LogPanel:
        return <LogPanel key="LogPanel" subscriptionId={this.props.data.subscriptionInfo.subscriptionId} limitHeight={false} />

      case ShippingStatusPanel:
        return <ShippingStatusPanel key="ShippingStatusPanel" subscriptionId={this.getOrderShippingId(this.props.data.subscriptionInfo.subscriptionId)} />

      case ShippingInfoPanel:
        return <ShippingInfoPanel 
                  key="ShippingInfoPanel" 
                  subscriptionId={this.getOrderShippingId(this.props.data.subscriptionInfo.subscriptionId)} 
                  title="Shipping Order Info" />

      case "subscriptionActions":
        return (
          <PanelGroupController title="Subscription Actions" key="subscriptionActions">
            <ActionButton
              label="Annotate Subscription"
              active={true}
              onClick={this.handleAnnotateSubscription.bind(this)}
              />
            <ActionButton 
              label="Change Address" 
              active={true}
              onClick={this.handleChangeAddress.bind(this)} />
            <ActionButton 
              label="Reschedule Delivery" 
              active={true}
              onClick={this.handleRescheduleDelivery.bind(this)} />
            <ActionButton 
              label="Change Quantity" 
              active={true}
              onClick={this.handleChangeQuantity.bind(this)} />
            <ActionButton 
              label="Change Frequency" 
              active={true}
              onClick={this.handleChangeFrequency.bind(this)} />
            <ActionButton 
              label="Rename Subscription" 
              active={true}
              onClick={this.handleRenameSubscription.bind(this)} />
            <ActionButton 
              label="Cancel Subscription" 
              active={true}
              onClick={this.handleCancelSubscription.bind(this)} />
            <ActionButton 
              label="Restart Subscription" 
              active={true}
              onClick={this.handleRestartSubscription.bind(this)} />
          </PanelGroupController>
        )

      case "deliveryActions":
        return (
          <PanelGroupController title="Delivery Actions" key="deliveryActions">
            <ActionButton 
              label="Manually Start Delivery" 
              onClick={this.handleStartDelivery.bind(this)} />
            <ActionButton 
              label="Retry Stock Reservation" 
              onClick={this.handleRetryStockReservation.bind(this)} />
            <ActionButton 
              label="Change Stock Reservation Warehouse" 
              onClick={this.handleChangeStockReservationWarehouse.bind(this)} />
            <ActionButton 
              label="Retry Scheduling" 
              onClick={this.handleRetryScheduling.bind(this)} />
          </PanelGroupController>
        )

      case NotesPanel:
        return <NotesPanel key="NotesPanel" foreignType={SUBSCRIPTION_TYPE} foreignId={this.props.data.subscriptionInfo.subscriptionId} />
  
      default:
        return null;      
    }
  } 

  getOrderShippingId() {
    const result = this.props.client.readFragment({
      id: `subscription-delivery:${this.props.data.subscriptionInfo.subscriptionId}`,
      fragment: gql`
        fragment myFrag on SubscriptionDelivery {
          shippingOrderId
        }
      `
    });       
    return result.shippingOrderId;
  }

  handlePanelItemSelection(id) {
    this.setState({selectedPanelId: id});
  }  

  handleSetSelection(id) {
    this.setState({deliveryId: id, hasDeliverySelection: true, selectedPanelId: "delivery"});
  }

  handleDeliveryIdClick(id, accountId) {
    this.props.requestViewSubscriptionDelivery(id);
  }

  handleChangeAddress() {
    this.props.requestChangeSubscriptionShippingAddress(this.props.data.subscriptionInfo.accountId, this.props.data.subscriptionInfo.subscriptionId);
  }
  handleChangeQuantity() {
    this.props.requestChangeSubscriptionQuantity(this.props.data.subscriptionInfo.subscriptionId);
  }
  handleChangeFrequency() {
    this.props.requestChangeSubscriptionFrequency(this.props.data.subscriptionInfo.subscriptionId);
  }
  handleRenameSubscription() {
    this.props.requestRenameSubscription(this.props.data.subscriptionInfo.subscriptionId);
  }
  handleCancelSubscription() {
    this.props.requestCancelSubscription(this.props.data.subscriptionInfo.subscriptionId);
  }
  handleRestartSubscription() {
    this.props.requestRestartSubscription(this.props.data.subscriptionInfo.subscriptionId);
  }
  handleRescheduleDelivery() {
    this.props.requestRescheduleSubscriptionDelivery(this.props.data.subscriptionInfo.subscriptionId);
  }
  handleStartDelivery() {
    this.props.requestStartDelivery(this.state.deliveryId);
  }
  handleRetryScheduling() {
    this.props.requestRetryScheduling(this.state.deliveryId);
  }
  handleRetryStockReservation() {
    this.props.requestRetryStockReservation(this.state.deliveryId);
  }  
  handleChangeStockReservationWarehouse() {
    this.props.requestChangeStockReservationWarehouse(this.state.deliveryId);
  }  
  
  handleAnnotateSubscription(e) {
    this.props.requestCreateNote(SUBSCRIPTION_TYPE, this.props.data.subscriptionInfo.subscriptionId);  
  }

  handleBack() {
    this.props.router.push(`/subscriptions`);
  }  

}

const SUBSCRIPTION_INFO = gql`
  query subscriptionInfo($subscriptionId:ID!) {
    subscriptionInfo(subscriptionId: $subscriptionId) {
      subscriptionId
      accountId
    }
  }
`;

const withQuery = graphql(SUBSCRIPTION_INFO, {
  options: (props) => ({
    fetchPolicy: "network-only",
    variables: {
      subscriptionId: props.params.subscriptionId
    }    
  })
})

export default connect(null, {
  requestChangeSubscriptionFrequency,
  requestChangeSubscriptionQuantity,
  requestChangeSubscriptionShippingAddress,
  requestRescheduleSubscriptionDelivery,
  requestCancelSubscription,
  requestRestartSubscription,
  requestRenameSubscription,
  requestViewSubscriptionDelivery,
  requestCreateNote
})(withApollo(withQuery(SubscriptionDeliveriesPage)));
